export default '2.3.2';



// WEBPACK FOOTER //
// ./src/lib/version.js